(function ($) {
  $(document).ready(function () {
    $(".tab-slider .content-outer .tab-wrapper:first").show();
    $(".tab-slider .tabs li:first").addClass("active");
    $(".tab-slider .tabs li").on("click", function (e) {
      e.preventDefault();
      $(this).addClass("active").siblings().removeClass("active");
      var index = $(this).index();
      $(".tab-slider .content-outer .tab-wrapper").hide();
      $(".tab-slider .content-outer .tab-wrapper").eq(index).show();
    });
  });

  // drop();
  // function drop() {
  //   var win_width = $(window).width();
  //   if (win_width <= 767) {
  //     $(".tab-slider .mobile-btn")
  //       .unbind()
  //       .on("click", function () {
  //         $(".tab-slider  .link-outer ul").slideToggle();
  //         $(".tab-slider .mobile-btn").toggleClass("rotate");
  //       });
  //     $(".tab-slider  .link-outer ul li").click(function (e) {
  //       e.preventDefault();
  //       var val = $(this).text();
  //       $(".tab-slider .mobile-btn p").html(val);
  //       if ($(".tab-slider  .link-outer ul").is(":visible")) {
  //         $(".tab-slider  .link-outer ul").slideUp();
  //         $(".tab-slider .mobile-btn").removeClass("rotate");
  //       }
  //     });
  //   }
  // }
  // $(window).resize(function () {
  //   drop();
  // });
})(jQuery);
